<template>
  <div class="enterpriseProject" @click="adminshow">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">{{ $t('项目管理.项目管理') }}</span>
        <div class="head-text">
          <!-- 新建事件 -->
          <el-input :placeholder="$t('项目管理.请输入项目名称')" class="search-input" v-model="query"></el-input>
          <el-button slot="append" icon="el-icon-search" @click="getprojectlist" class="mar-r80"></el-button>
          <el-button type="primary" @click="addProjectOpen">{{ $t('项目管理.新建项目') }}</el-button>
          <!-- <el-button type="primary" @click="modelList3Open">模型管理器</el-button> -->
        </div>
      </div>
      <el-container>
        <!-- 这里是侧边栏-->
        <div class="mar-top20">
          <el-aside width="200px" class="elAside">
            <el-button type="primary" size="small" @click="showAll">{{ $t('项目管理.显示全部项目') }}</el-button>
            <div class="zTreeDiv">
              <ul id="deptTree" class="ztree"></ul>
            </div>
            <div id="deptRemenu">
              <ul>
                <li id="addDept">{{ $t('common.添加') }}</li>
                <li id="updateDept">{{ $t('common.修改') }}</li>
                <li id="delDept">{{ $t('common.删除') }}</li>
              </ul>
            </div>
          </el-aside>
        </div>
        <el-main>
          <!-- //表格 -->
          <div class="enterpriseProject-table">
            <el-table class="margin-20 table width100" v-loading="loading" :data="projectList" height="72vh"
              @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column align="center" type="index" :label="$t('项目管理.序号')" width="80"></el-table-column>
              <el-table-column align="center" prop="proj03" :label="$t('项目管理.项目名称')"></el-table-column>
              <el-table-column align="center" prop="proj07" :label="$t('项目管理.项目简称')"></el-table-column>
              <el-table-column align="center" prop="proj02" :label="$t('项目管理.项目编号')"></el-table-column>
              <el-table-column align="center" prop="admin" :label="$t('项目管理.BIM负责人')"></el-table-column>
              <!-- <el-table-column
                align="center"
                prop="proj08"
                label="合同金额"
              ></el-table-column> -->
              <el-table-column align="center" :label="$t('项目管理.所属分组')" width="150">
                <template slot-scope="scope">
                  <el-cascader @change="(val) => genggai([val, scope.row])" :options="suoshuType" :props="{
                    checkStrictly: true,
                    value: 'ID',
                    label: 'label',
                    children: 'children',
                  }" clearable :placeholder="scope.row.prgp02"></el-cascader>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="proj10" :label="$t('项目管理.项目类型')"></el-table-column>
              <el-table-column align="center" prop="proj15" :label="$t('项目管理.建设单位')"></el-table-column>
              <el-table-column align="center" prop="proj13" :label="$t('项目管理.项目地点')"></el-table-column>
              <!-- <el-table-column
                align="center"
                prop="phone"
                label="经理电话"
              ></el-table-column> -->
              <el-table-column align="center" prop="proj22" :label="$t('项目管理.创建时间')"></el-table-column>
              <el-table-column align="center" :label="$t('common.操作')" width="260">
                <template slot-scope="scope">
                  <el-button size="small" plain type="primary" @click="modelList(scope.row)">{{ $t('项目管理.模型')
                  }}</el-button>
                  <el-button size="small" type="primary" plain @click="seeDialogFormVisible(scope.row)">{{
                    $t('common.修改') }}</el-button>
                  <!-- <el-button size="small" type="primary" plain
                    @click="functionalityDialog(scope.row.proj01)">功能</el-button> -->
                  <el-button size="small" type="primary" plain @click="DelProject(scope.row)">{{ $t('common.删除')
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-pagination align="center" class="mar-top20" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 50, 100]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-main>
      </el-container>

      <el-dialog :close-on-click-modal="false" :title="$t('新建项目.新建项目')" :visible.sync="addProject" width="70%"
        top="0.5%">
        <el-row>
          <el-col :span="11" :offset="1">
            <el-form :model="addForm" label-width="170px" ref="addForm" :rules="addFormRules">
              <el-form-item :label="$t('新建项目.项目编号')" prop="proj02">
                <el-input v-model="addForm.proj02" auto-complete="off" :placeholder="$t('common.请填写必填项')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.项目名称')" prop="proj03">
                <el-input v-model="addForm.proj03" auto-complete="off" :placeholder="$t('common.请填写必填项')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.BIM负责人')" prop="admin">
                <el-select style="width: 100%" filterable v-model="addForm.admin" :placeholder="$t('common.请填写必填项')">
                  <el-option :label="item.Name" :value="item.id" v-for="item in CompanUserList"
                    :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('新建项目.所属分组')" prop="proj06">
                <el-cascader style="width: 100%" @change="xz" :placeholder="$t('common.请填写必填项')" :options="suoshuType"
                  :props="{
                    checkStrictly: true,
                    value: 'ID',
                    label: 'label',
                    children: 'children',
                  }" clearable></el-cascader>
              </el-form-item>
              <el-form-item :label="$t('新建项目.项目类型')" prop="proj10">
                <el-select style="width: 100%" filterable v-model="addForm.proj10" :placeholder="$t('common.请填写必填项')">
                  <el-option :label="item" :value="item"
                    v-for="item in [$t('新建项目.一次设计'), $t('新建项目.深化设计'), $t('新建项目.外包设计')]" :key="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('新建项目.项目简称')" prop="proj07">
                <el-input v-model="addForm.proj07" auto-complete="off" :placeholder="$t('common.请填写必填项')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.合同金额')" prop="proj08">
                <el-input type="textarea" v-model="addForm.proj08" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.BIM耗时')" prop="proj09">
                <el-input type="textarea" v-model="addForm.proj09" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.服务阶段')" prop="proj11">
                <el-input type="textarea" v-model="addForm.proj11" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.总体投资')" prop="proj19">
                <el-input type="textarea" v-model="addForm.proj19" auto-complete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form :model="addForm" label-width="170px" ref="addForm2" :rules="addFormRules">
              <el-form-item :label="$t('新建项目.项目规模')" prop="proj12">
                <el-input type="textarea" v-model="addForm.proj12" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.项目地点')" prop="proj13">
                <el-input v-model="addForm.proj13" auto-complete="off"></el-input>
                <!-- <div class="container">
                  <div class="dome-main">
                    <div class="city-picker-selector" id="city-picker-selector1"></div>
                  </div>
                </div>
                <el-input v-model="detialAdree" type="textarea"></el-input> -->
              </el-form-item>
              <el-form-item :label="$t('新建项目.总体工期')" prop="proj14">
                <el-input type="textarea" v-model="addForm.proj14" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.建设单位')" prop="proj15">
                <el-input type="textarea" v-model="addForm.proj15" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.设计单位')" prop="proj16">
                <el-input type="textarea" v-model="addForm.proj16" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.施工单位')" prop="proj17">
                <el-input type="textarea" v-model="addForm.proj17" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.监理单位')" prop="proj18">
                <el-input type="textarea" v-model="addForm.proj18" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('新建项目.开工竣工')" prop="proj20">
                <el-date-picker v-model="addForm.Time" type="daterange" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" :start-placeholder="$t('新建项目.开工日期')"
                  :end-placeholder="$t('新建项目.竣工日期')"></el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" :offset="9">
            <el-button type="primary" @click="addProjectInfo('addForm', 'addForm2')">{{ $t('common.确定') }}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" @click="resetAdd">{{ $t('common.取消') }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 这里是模型列表 -->
      <el-dialog :close-on-click-modal="false" :title="$t('模型列表.模型列表')" :visible.sync="modelList1" width="90%" top="2%">
        <div class="mx-table">
          <el-row>
            <el-col :span="12" :offset="12">
              <div class="float-rig">
                <el-input :placeholder="$t('模型列表.请输入模型名称')" class="search-input" v-model="modelQuery3"></el-input>
                <el-button icon="el-icon-search" @click="modelListInfo"></el-button>
              </div>
            </el-col>
          </el-row>
          <el-table class="margin-20 table width100" v-loading="loading" :data="ModelList3" height="400px"
            @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <!-- <el-table-column align="center" prop="mode01" label="ID"></el-table-column> -->
            <el-table-column align="center" type="index" :label="$t('模型列表.序号')" width="80"></el-table-column>
            <el-table-column align="center" prop="mode02" :label="$t('模型列表.文件名称')"></el-table-column>
            <!-- <el-table-column align="center" prop="mode03" :label="$t('模型列表.专业备注')"></el-table-column> -->
            <el-table-column align="center" prop="mode10" :label="$t('模型列表.文件大小')">
              <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
            </el-table-column>
            <el-table-column align="center" prop="mode04" :label="$t('模型列表.上传文件大小')">
              <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
            </el-table-column>
            <el-table-column align="center" prop="mode05" :label="$t('模型列表.版本备注')"></el-table-column>
            <el-table-column align="center" prop="mode06" :label="$t('模型列表.联系人')"></el-table-column>
            <el-table-column align="center" prop="mode07" :label="$t('模型列表.邮箱')"></el-table-column>
            <el-table-column align="center" prop="mode08" :label="$t('模型列表.电话')"></el-table-column>
            <el-table-column align="center" prop="mode03" :label="$t('模型列表.备注')"></el-table-column>
            <el-table-column align="center" prop="mode11" :label="$t('模型列表.更新时间')" sortable></el-table-column>
            <el-table-column align="center" :label="$t('模型列表.操作')" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" plain @click="modelView(scope.row)">{{ $t('模型列表.浏览')
                }}</el-button>
                <!-- <el-button size="mini" type="primary" plain @click="deleteModel(scope.row)">{{ $t('模型列表.卸载')
                }}</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination align="center" class="mar-top20" @size-change="handleSizeChange7"
          @current-change="handleCurrentChange7" :current-page="1" :page-sizes="[10, 50, 100]" :page-size="pageSize6"
          layout="total, sizes, prev, pager, next, jumper" :total="total7"></el-pagination>
        <!-- <el-row class="mar-top20">
          <el-col :span="2" :offset="12">
            <el-button type="primary" @click="modelList2Open">{{ $t('模型列表.加载模型') }}</el-button>
          </el-col>
        </el-row> -->
      </el-dialog>
      <!-- 这里是超管设置的还未关联的 -->
      <el-dialog :close-on-click-modal="false" :title="$t('模型列表.模型列表')" :visible.sync="modelList2" width="90%">
        <el-row>
          <el-col :span="8" :offset="16">
            <el-input :placeholder="$t('模型列表.请输入模型名称')" class="search-input" v-model="modelQuery2"></el-input>
            <el-button icon="el-icon-search" @click="modelList2Open" class="mar-r80"></el-button>
          </el-col>
        </el-row>
        <div class="mxjz-table">
          <el-table class="margin-20 table width100" height="500px" v-loading="loading" :data="ModelList2"
            @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <!-- <el-table-column align="center" prop="mode01" label="ID" width="80"></el-table-column> -->
            <el-table-column align="center" type="index" :label="$t('模型列表.序号')"></el-table-column>
            <el-table-column align="center" prop="mode02" :label="$t('模型列表.文件名称')"></el-table-column>
            <!-- <el-table-column align="center" prop="mode03" :label="$t('模型列表.专业备注')"></el-table-column> -->
            <el-table-column align="center" prop="mode10" :label="$t('模型列表.文件大小')">
              <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
            </el-table-column>
            <el-table-column align="center" prop="mode04" :label="$t('模型列表.上传文件大小')">
              <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
            </el-table-column>
            <el-table-column align="center" prop="mode05" :label="$t('模型列表.版本备注')"></el-table-column>
            <el-table-column align="center" prop="mode06" :label="$t('模型列表.联系人')"></el-table-column>
            <el-table-column align="center" prop="mode07" :label="$t('模型列表.邮箱')"></el-table-column>
            <el-table-column align="center" prop="mode08" :label="$t('模型列表.电话')"></el-table-column>
            <el-table-column align="center" prop="mode03" :label="$t('模型列表.备注')"></el-table-column>
            <el-table-column align="center" prop="mode11" :label="$t('模型列表.更新时间')" sortable></el-table-column>
            <el-table-column align="center" :label="$t('模型列表.操作')" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" plain @click="modelView(scope.row)">{{ $t('模型列表.浏览')
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="mar-top30" align="center" @size-change="handleSizeChange6"
            @current-change="handleCurrentChange6" :current-page="pageIndex5" :page-sizes="[10, 50, 100]"
            :page-size="pageSize5" layout="total, sizes, prev, pager, next, jumper" :total="total6"></el-pagination>
          <el-row>
            <el-col class="mar-top20" :span="4" :offset="12">
              <el-button type="primary" @click="jiazaiModel">{{ $t('模型列表.确定加载') }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <!-- 这里是模型管理器 -->
      <el-dialog :close-on-click-modal="false" title="模型管理器" :visible.sync="modelList3" width="80%">
        <el-row>
          <el-col :span="12" :offset="12">
            <div class="float-rig">
              <el-input placeholder="请输入项目名称" class="search-input" v-model="modelQuery"></el-input>
              <el-button icon="el-icon-search" @click="modelList3Open"></el-button>
            </div>
          </el-col>
        </el-row>
        <el-table class="margin-20 table width100" v-loading="loading" :data="ModelList"
          @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <!-- <el-table-column align="center" prop="mode01" label="ID" width="80"></el-table-column> -->
          <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
          <el-table-column align="center" prop="mode02" label="文件名称"></el-table-column>
          <el-table-column align="center" prop="mode03" label="楼层备注"></el-table-column>
          <el-table-column align="center" prop="mode03" label="专业备注"></el-table-column>
          <el-table-column align="center" prop="mode10" label="文件大小">
            <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
          </el-table-column>
          <el-table-column align="center" prop="mode04" label="上传文件大小">
            <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
          </el-table-column>
          <el-table-column align="center" prop="mode05" label="版本备注"></el-table-column>
          <el-table-column align="center" prop="mode06" label="联系人"></el-table-column>
          <el-table-column align="center" prop="mode07" label="邮箱"></el-table-column>
          <el-table-column align="center" prop="mode08" label="电话"></el-table-column>
          <el-table-column align="center" prop="mode11" label="更新时间" sortable></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="modelView(scope.row)">浏览</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination align="center" @size-change="handleSizeChange5" @current-change="handleCurrentChange5"
          :current-page="pageIndex4" :page-sizes="[10, 50, 100]" :page-size="pageSize4"
          layout="total, sizes, prev, pager, next, jumper" :total="total5"></el-pagination>
        <el-row>
          <el-col :span="4" :offset="12">
            <el-button type="primary" @click="this.modelList3 = false">确定</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 查看项目详情 -->
      <el-dialog :close-on-click-modal="false" :title="$t('新建项目.项目详情')" :visible.sync="projectDetails" top="2%"
        width="60%">
        <el-row>
          <el-col :span="12" :offset="2">
            <div class="user-loading user-loading-img" v-for="(i, index) in examineData" :key="index">
              <p>
                <strong style="width:200px;display: inline-block;">
                  <img :src="i.img" alt />
                  {{ i.name }}
                </strong>
                <el-select filterable @change="Update" v-show="i.name == $t('新建项目.BIM负责人')" v-model="BmUserID" multiple
                  :placeholder="$t('common.请填写必填项')" style="width: 170px;">
                  <el-option v-for="(item, index) in BmUserData" :key="index" :label="item.Name"
                    :value="item.id"></el-option>
                </el-select>
                <span v-if="
                  i.name == $t('新建项目.合同金额') ||
                  i.name == $t('新建项目.BIM耗时') ||
                  i.name == $t('新建项目.项目地点') ||
                  i.name == $t('新建项目.项目类型')
                ">{{ i.data }}</span>
                <el-input v-else-if="i.name == $t('新建项目.项目编号')" v-model="i.data" class="width180"
                  :disabled="false"></el-input>
                <el-input v-else-if="i.name != $t('新建项目.BIM负责人')" v-model="i.data" class="width180"></el-input>
              </p>
            </div>
          </el-col>
          <el-col :span="8" :offset="1">
            <div class="user-loading" v-for="(i, index) in examineData2" :key="index">
              <strong style="width:200px;display: inline-block;">
                <img :src="i.img" alt />
                {{ i.name }}
              </strong>
              <p>
                <span>{{ i.data }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="20" :offset="2">
            {{ $t('新建项目.项目概况') }}
            <el-input readonly type="textarea" rows="4" v-model="projectsCentent"
              style="margin-top: 10px;"></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="mar-top20" :offset="12">
            <el-button type="primary" @click="addbtn">{{ $t('common.确定') }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="更改所属" :visible.sync="updataBelong" width="30%">
        <el-table :data="tableData" stripe border highlight-current-row @current-change="handleCurrentChange2"
          ref="singleTable" class="width100">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="prgp02" label="分组名称"></el-table-column>
        </el-table>
        <el-row>
          <el-col :span="4" :offset="7">
            <el-button type="primary" @click="UpdateProjectg">确定</el-button>
          </el-col>
          <el-col :span="4" :offset="2">
            <el-button type="danger" @click="updataBelong = false">取消</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 企管功能弹窗 -->
      <functionaly ref="functionaly"></functionaly>
    </el-card>
  </div>
</template>

<script>
import functionaly from "@/components/functionaly.vue";
import {
  GetProjectDept,
  DelProject,
  GetCompanyProjectList,
  AddProject,
  GetProjectgroupTree,
  FindProjectgroup,
  GetProjectGroupList,
  GetCompanUserList,
  GetProjectInfo,
  GetModelList,
  GetProjectModelList,
  AddProjectModel,
  DelProjectMdoel,
  UpdateProjectGroup,
  updateProjectManagement,
  UpdateProjectManager,
  AddCorporateGovernanceRen,
  GetProjectgroupZTree,
  AddProjectgroup,
  DelProjectgroup,
  EditProjectgroup,
  ChangeProjectGroupOrder,
  GetProjectNumber,
} from "@/setAxios.js";
import template from "../project/ProjectSettings/barCode/template.vue";
let id = 1000;
export default {
  components: { template, functionaly },
  name: "enterpriseProject",
  data() {
    return {
      isXmBh: "",
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      defaultExpand: true,
      tableData: [],
      addModelList: {
        mode02: "",
        mode03: "",
        mode04: "",
        mode05: "",
        mode06: "",
        mode07: "",
        mode08: "",
        mode09: "",
        mode13: "",
      },
      // 项目相信内容
      projectsCentent: "",
      // 这是部门详情
      deptNum: 0,
      deptInfo: [],
      query: "",
      userList: {},
      // 这里是选中得模型
      multipleSelection: [],
      loading: false,
      addProject: false,
      modelList1: false,
      modelList2: false,
      modelList3: false,
      projectDetails: false,
      updataBelong: false,
      bid: "",
      pageIndex: 1,
      pageSize: 10,
      pageSize4: 10,
      pageIndex4: 1,
      pageSize5: 10,
      pageIndex5: 1,
      pageSize6: 10,
      pageIndex6: 1,
      modelQuery: "",
      modelQuery2: "",
      modelQuery3: "",
      total: 0,
      total5: 0,
      total6: 0,
      total7: 0,
      addForm: {
        proj02: "",
        proj03: "",
        proj04: "",
        proj05: localStorage.getItem("pid"),
        proj06: "",
        proj07: "",
        proj08: "",
        proj09: "",
        proj10: "",
        proj11: "",
        proj12: "",
        proj13: "",
        proj14: "",
        proj15: "",
        proj16: "",
        proj17: "",
        proj18: "",
        proj19: "",
        proj20: "",
        proj21: "",
        Time: "",
      },
      addFormRules: {
        proj02: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
        proj03: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
        admin: [{ required: true, message: this.$t('common.请填写必填项'), trigger: "blur" }],
        proj06: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
        proj07: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
        proj10: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
      },
      CompanUserList: [],
      ModelList: [],
      ModelList2: [],
      ModelList3: [],
      projectList: [],
      examineData: [
        {
          name: this.$t('新建项目.项目编号'),
          data: "",
          img: require("@/assets/img/bh.png"),
        },
        {
          name: this.$t('新建项目.项目简称'),
          data: "",
          img: require("@/assets/img/kj.png"),
        },
        {
          name: this.$t('新建项目.项目名称'),
          data: "",
          img: require("@/assets/img/xm.png"),
        },
        {
          name: this.$t('新建项目.BIM负责人'),
          data: "",
          img: require("@/assets/img/ren.png"),
        },
        {
          name: this.$t('新建项目.合同金额'),
          data: "",
          img: require("@/assets/img/ht.png"),
        },
        {
          name: this.$t('新建项目.BIM耗时'),
          data: "",
          img: require("@/assets/img/mx.png"),
        },
        {
          name: this.$t('新建项目.项目地点'),
          data: "",
          img: require("@/assets/img/dz.png"),
        },
        {
          name: this.$t('新建项目.项目类型'),
          data: "",
          img: require("@/assets/img/jzlx.png"),
        },
      ],
      examineData2: [
        {
          name: this.$t('新建项目.服务阶段'),
          data: "",
          img: require("@/assets/img/fwjd.png"),
        },
        {
          name: this.$t('新建项目.项目规模'),
          data: "",
          img: require("@/assets/img/xmmj.png"),
        },
        {
          name: this.$t('新建项目.总体工期'),
          data: "",
          img: require("@/assets/img/sj.png"),
        },
        {
          name: this.$t('新建项目.建设单位'),
          data: "",
          img: require("@/assets/img/jsdw.png"),
        },
        {
          name: this.$t('新建项目.设计单位'),
          data: "",
          img: require("@/assets/img/sjdw.png"),
        },
        {
          name: this.$t('新建项目.施工单位'),
          data: "",
          img: require("@/assets/img/sgdw.png"),
        },
        {
          name: this.$t('新建项目.监理单位'),
          data: "",
          img: require("@/assets/img/jldw.png"),
        },
        {
          name: this.$t('新建项目.总体投资'),
          data: "",
          img: require("@/assets/img/ztz.png"),
        },
        {
          name: this.$t('新建项目.开工日期'),
          data: "",
          img: require("@/assets/img/sj.png"),
        },
        {
          name: this.$t('新建项目.计划竣工'),
          data: "",
          img: require("@/assets/img/rl-2.png"),
        },
        {
          name: this.$t('新建项目.创建日期'),
          data: "",
          img: require("@/assets/img/sj.png"),
        },
      ],
      userList: [],
      dataDept: [],
      Objs: {},
      deptName: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      detialAdree: "",
      prgp01: "",
      xid: "",
      BmUserID: "",
      BmUserData: {},
      XmID: "",
      suoshuType: [],
      ids: "null",
    };
  },
  created() { },
  mounted() {
    this.GetProjectgroupZTree();
  },
  methods: {
    DelProject(data) {
      this.$confirm(this.$t('common.删除询问'), this.$t('common.提示'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        type: "warning",
      }).then(async () => {
        let params = {
          qid: localStorage.pid,
          xid: data.proj01,
        };
        let res = await DelProject(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.getprojectlist();
        } else {
          this.$message({
            type: "warning",
            message: this.$t('common.处理失败'),
          });
        }
      });
    },
    // 更改所属
    async genggai(data) {
      let params = {
        gid: data[0][data[0].length - 1],
        pid: data[1].proj01,
      };
      let res = await UpdateProjectGroup(params);
      this.$message({
        type: res.Code > 0 ? "success" : "warning",
        message: res.Code > 0 ? this.$t('common.处理成功') : this.$t('common.处理失败'),
      });
      this.getprojectlist();
    },
    xz(data) {
      this.addForm.proj06 = data[data.length - 1];
    },
    removeNull(arr) {
      arr.forEach((ele) => {
        if (ele.children == undefined)
          return
        if (ele.children.length == 0) {
          delete ele.children;
        } else {
          this.removeNull(ele.children);
        }
      });
    },
    // 初始化Ztree
    init() {
      var _this = this;

      var selectNode;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "prgp02",
          },
          simpleData: {
            enable: true,
            idKey: "prgp01",
            pIdKey: "prgp05",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          onCheck: onCheck,
          beforeDrop: beforeDrop,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init($("#deptTree"), setting, this.zNodes);
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.prgp01;
        _split = ",";
      });
      _this.getprojectlist();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.prgp01;
          _split = ",";
        });
        _this.getprojectlist();
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeProjectGroupOrder({
              oid: moveNode.prgp01,
              nid: targetNode.prgp01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功'),
            });
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.deptNum = treeNode.prgp01;
        _this.pageIndex = 1;
        _this.ids = treeNode.prgp01;
        _this.getprojectlist();
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "deptRemenu" ||
            $(event.target).parents("#deptRemenu").length > 0
          )
        ) {
          $("#deptRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addDept").show();
          $("#updateDept").hide();
          $("#delDept").hide();
        } else {
          $("#addDept").show();
          $("#updateDept").show();
          $("#delDept").show();
        }
        $("#deptRemenu").show();
        $("#deptRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#deptRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#deptRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDept") {
            var newNode = {},
              params = {};
            var node = _this.selectNode;
            params = {
              prgp01: 0,
              prgp02: _this.$t('common.新建节点'),
              prgp03: localStorage.getItem("pid"),
              prgp04: new Date(),
              prgp05: _this.selectNode == null ? 0 : _this.selectNode.prgp01,
            };
            AddProjectgroup({ model: JSON.stringify(params) }).then((res) => {
              if (res.Code > 0) {
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                _this.$message({
                  type: "success",
                  message: _this.$t('common.处理成功'),
                });
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "prgp01",
                  newNode.prgp01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: _this.$t('common.处理失败'),
                });
              }
            });
          } else if (type == "delDept") {
            _this.$confirm(_this.$t('common.删除询问')).then((_) => {
              let params = { ids: _this.selectNode.prgp01 };
              DelProjectgroup(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: _this.$t('common.处理成功'),
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "prgp01",
                    _this.selectNode.prgp01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "waring",
                    message: _this.$t('common.处理失败'),
                  });
                }
              });
            });
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.prgp02) {
          let params = {
            prgp01: treeNode.prgp01,
            prgp02: newName,
            prgp03: treeNode.prgp03,
            prgp04: treeNode.prgp04,
            prgp05: treeNode.prgp05,
            prgp06: treeNode.prgp06,
          };
          EditProjectgroup({ model: params }).then((res) => {
            _this.$message({
              type: "success",
              message: _this.$t('common.处理成功'),
            });
          });
        }
      }
    },
    UpdateProjectg() {
      let params = {
        pid: this.xid,
        gid: this.gid2,
      };
      UpdateProjectGroup(params).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: _this.$t('common.处理成功'),
          });
          this.updataBelong = false;
        }
      });
    },
    showAll() {
      this.ids = "null";
      this.getprojectlist();
    },
    // 取消提交添加
    resetAdd() {
      this.addProject = false;
      this.addForm = {
        proj02: "",
        proj03: "",
        proj04: "",
        proj05: localStorage.getItem("pid"),
        proj06: "",
        proj07: "",
        proj08: "",
        proj09: "",
        proj10: "",
        proj11: "",
        proj12: "",
        proj13: "",
        proj14: "",
        proj15: "",
        proj16: "",
        proj17: "",
        proj18: "",
        proj19: "",
        proj20: "",
        proj21: "",
      };
    },
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector1").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.addForm.proj13 = selector1.getCityNameVal();
        },
      });
    },
    // 这里是新建项目
    async addProjectOpen() {
      // if (this.deptNum == 0) {
      //   this.$message({
      //     type: "warning",
      //     message: "请先选择分组后创建项目"
      //   });
      // } else {
      this.addProject = true;
      var params = {
        pid: localStorage.getItem("pid"),
      };
      let res = await GetProjectgroupTree({ params });
      this.removeNull(res.Data);
      this.suoshuType = res.Data;
      // setTimeout(() => {
      //   this.first();
      // }, 300);
      params = {
        bids: "null",
        seachword: "",
        pid: localStorage.getItem("pid"),
        pageIndex: 1,
        pageSize: 100000,
      };
      GetCompanUserList({ params }).then((res) => {
        this.CompanUserList = res.Data.list;
      });
      params = {
        qid: localStorage.getItem("pid"),
      };
      GetProjectNumber({ params }).then((res) => {
        this.addForm.proj02 = res.Data;
      });
    },
    // 添加项目
    addProjectInfo(form1, form2) {
      this.$refs[form1].validate((valid) => {
        if (valid) {
          this.$refs[form2].validate((valid) => {
            if (valid) {
              this.addForm.proj20 = this.addForm.Time[0];
              this.addForm.proj21 = this.addForm.Time[1];
              // this.addForm.proj02 = this.addForm.proj02;
              try {
                this.addForm.proj13 =
                  this.addForm.proj13.split("/")[0] + "/" + this.detialAdree;
              } catch (error) {
                this.$message({
                  type: "warning",
                  message: "请检查地址",
                });
                return;
              }
              let params = JSON.stringify(this.addForm);
              AddProject({ model: params }).then((res) => {
                if (res.Code == 1) {
                  this.$message({
                    type: "success",
                    message: "添加成功",
                  });
                  this.addProject = false;
                  this.GetProjectDept();
                } else {
                  this.$message({
                    type: "waring",
                    message: "添加失败",
                  });
                }
              });
            }
          });
        }
      });
    },
    // 获取企业下的部门
    GetProjectDept() {
      this.loading = true;
      let params = {
        pid: localStorage.getItem("pid"),
      };
      GetProjectgroupZTree(params).then((res) => {
        this.dataDept = res.Data;
        this.loading = false;
        //(res, "企业下的部门");
        this.bid = "";
        this.getprojectlist();
      });
    },
    async GetProjectgroupZTree() {
      this.loading = true;
      var params = {
        pid: localStorage.getItem("pid"),
      };
      GetProjectgroupZTree(params).then((res) => {
        this.dataDept = res.Data;
        this.zNodes = res.Data;
        this.init(res.Data);
        this.loading = false;
        //(res, "企业下的部门");
        this.bid = "";
      });

      let res = await GetProjectgroupTree({ params });
      this.removeNull(res.Data);
      this.suoshuType = res.Data;
    },
    // 切换部门
    handleNodeClick(data) {
      this.bid = data.ID;
      this.getprojectlist();
    },
    // 产找部门下的项目
    getprojectlist() {
      let params = {
        seachword: this.query,
        bid: this.ids,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        qid: localStorage.getItem("pid"),
      };
      // 这里是获得部门下得项目
      GetCompanyProjectList({ params }).then((res) => {
        this.projectList = res.Data.lsit;
        this.total = res.Data.total;
      });
    },
    modelList(row) {
      this.modelList1 = true;
      localStorage.setItem("xid", row.proj01);
      this.modelListInfo();
    },
    modelListInfo() {
      let params = {
        xid: localStorage.getItem("xid"),
        seachword: this.modelQuery3,
        pageIndex: this.pageIndex6,
        pageSize: this.pageSize6,
      };
      GetProjectModelList({ params }).then((res) => {
        this.ModelList3 = res.Data.list;
        this.total7 = res.Data.total;
      });
    },
    deleteDialogFormVisible(row) {
      this.updataBelong = true;
      this.xid = row.proj01;
      let params = {
        pid: localStorage.getItem("pid"),
      };
      GetProjectGroupList({ params }).then((res) => {
        this.tableData = res.Data;
      });
    },
    // 查看项目详情
    seeDialogFormVisible(row) {
      this.projectDetails = true;
      this.XmID = row.proj01;
      let params = {
        id: row.proj01,
      };
      GetProjectInfo({ params }).then((res) => {
        if (res.Data.user01) {
          this.BmUserID = res.Data.user01.split(",").map(Number);
        } else {
          this.BmUserID = [];
        }
        this.examineData[0].data = res.Data.proj02;
        this.examineData[1].data = res.Data.proj07;
        this.examineData[2].data = res.Data.proj03;
        this.examineData[3].data = res.Data.admin;
        this.examineData[4].data = res.Data.proj08;
        this.examineData[5].data = res.Data.proj09;
        this.examineData[6].data = res.Data.proj13;
        this.examineData[7].data = res.Data.proj10;
        // ----
        this.examineData2[0].data = res.Data.proj11;
        this.examineData2[1].data = res.Data.proj12;
        this.examineData2[2].data = res.Data.proj14;
        this.examineData2[3].data = res.Data.proj15;
        this.examineData2[4].data = res.Data.proj16;
        this.examineData2[5].data = res.Data.proj17;
        this.examineData2[6].data = res.Data.proj18;
        this.examineData2[7].data = res.Data.proj19;
        this.examineData2[8].data = res.Data.proj20;
        this.examineData2[9].data = res.Data.proj21;
        this.examineData2[10].data = res.Data.proj22;
        this.projectsCentent = res.Data.proj23;
        this.Objs = res.Data;
      });
      params = {
        bids: "null",
        seachword: "",
        pid: localStorage.getItem("pid"),
        pageIndex: 1,
        pageSize: 10000,
      };
      AddCorporateGovernanceRen({ params }).then((res) => {
        this.BmUserData = res.Data.list;
      });
    },
    // 模型管理器
    modelList3Open() {
      let params = {
        bid: localStorage.getItem("pid"),
        seachword: this.modelQuery,
        pageIndex: this.pageIndex4,
        pageSize: this.pageSize4,
      };
      GetModelList({ params }).then((res) => {
        this.ModelList = res.Data.list;
        this.total5 = res.Data.total;
      });
      this.modelList3 = true;
    },
    // 加载模型
    jiazaiModel() {
      let multipleSelection2 = [];
      this.multipleSelection.forEach((element) => {
        multipleSelection2.push(element.mode01);
      });
      let params = {
        xid: localStorage.getItem("xid"),
        mids: multipleSelection2.toString(),
      };
      if (multipleSelection2.length > 0) {
        AddProjectModel({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功'),
            });
            this.modelList2 = false;
            this.modelListInfo();
          } else {
            this.$message({
              type: "success",
              message: this.$t('common.处理失败'),
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: this.$t('common.请选择数据'),
        });
      }
    },
    // 打开模型加载
    modelList2Open() {
      let params = {
        bid: localStorage.getItem("pid"),
        seachword: this.modelQuery2,
        pageIndex: this.pageIndex5,
        pageSize: this.pageSize5,
        isFree: "true",
      };
      GetModelList({ params }).then((res) => {
        this.ModelList2 = res.Data.list;
        this.total6 = res.Data.total;
      });
      this.modelList2 = true;
    },
    // 卸载模型
    deleteModel(row) {
      let params = {
        mid: row.mode01,
      };
      DelProjectMdoel({ ...params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.modelListInfo();
        }
      });
    },
    // 浏览模型
    modelView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node mar-top10">
          <span>{node.label}</span>
          <span class="mar-left10">
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              添加
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              删除
            </el-button>
          </span>
        </span>
      );
    },
    handleChange(value) {
      //(value);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "二级 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getData() {
      this.GetProjectDept();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSizeChange5(val) {
      this.pageSize4 = val;
      this.modelList3Open();
    },
    handleCurrentChange5(val) {
      this.pageIndex4 = val;
      this.modelList3Open();
    },
    handleSizeChange6(val) {
      this.pageSize5 = val;
      this.modelList2Open();
    },
    handleCurrentChange6(val) {
      this.pageIndex5 = val;
      this.modelList2Open();
    },
    handleSizeChange7(val) {
      this.pageSize6 = val;
      this.modelListInfo();
    },
    handleCurrentChange7(val) {
      this.pageIndex6 = val;
      this.modelListInfo();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getData();
    },
    handleCurrentChange2(val) {
      //(val);
      this.gid2 = val.prgp01;
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
    addbtn() {
      this.projectDetails = false;
      this.Objs.proj03 = this.examineData[2].data;
      this.Objs.proj02 = this.examineData[0].data;
      this.Objs.proj04 = this.examineData[7].data;
      this.Objs.proj07 = this.examineData[1].data;
      let params = JSON.stringify(this.Objs);
      updateProjectManagement({ project: params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "修改成功！",
          });
          this.getData();
        } else {
          this.$message().error("修改失败");
        }
      });
    },
    Update() {
      let params = {
        xid: this.XmID,
        uid: this.BmUserID.join(","),
      };
      UpdateProjectManager(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "更换经理成功！",
          });
          this.getData();
        } else {
          this.$message().error("更换经理失败");
        }
      });
    },
    // -----功能------
    functionalityDialog(id) {
      this.$refs.functionaly.xid = id;
      this.$refs.functionaly.open();
    },
  },
};
</script>

<style lang="less" scoped>
div#deptRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#deptRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#deptRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#deptRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#deptTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

.search-input {
  width: 300px;
}

.el-main {
  padding: 0;
}

.page {
  padding: 5px 0;
  width: 100%;
  background-color: #d3dce6;
}

.user-loading {
  display: flex;
  margin: 10px 0;

  p {
    margin: 8px 0 0 10px;

    span {
      color: #007acc;
    }
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.container {
  margin: 0px;
}

.dome-main {
  padding: 0px;
}

/deep/ .enterpriseProject-table .el-input__inner::-webkit-input-placeholder {
  color: #000000;
}

// 新增
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.mar-r80 {
  margin-right: 80px;
}

.mar-top20 {
  margin-top: 20px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}

.width100 {
  width: 100%;
}

.float-rig {
  float: right;
}

.mar-top30 {
  margin-top: 30px;
}

.mar-left10 {
  margin-left: 10px;
}

.width80 {
  width: 80%;
}

.width180 {
  width: 180px;
}

.mar-top10 {
  margin-top: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #cdcdcd;
  padding: 20px;
}
</style>
